import { fb, validators } from '../../../lib/form';

export function getContactModel(data) {
  let countryList = ["Australia", "International"].map(x => { return { name: x, value: x }});
  countryList = [ {name: "Choose Country", value: ""}, ...countryList];

  let stateList = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"].map(x => { return { name: x, value: x }});
  stateList = [ {name: "Choose State", value: ""}, ...stateList];

  let serviceList = ["New Equipment", "Spare Parts", "Service", "General Enquiries"].map(x => { return { name: x, value: x }});
  serviceList = [ {name: "Reason for Contacting", value: ""}, ...serviceList];

  const model = fb.group({
    name: [data.name || '', [validators.Required()], { label: 'Name', type: 'text' }],
    email: [data.email || '', [validators.Required(), validators.Email()], { label: 'Email', type: 'email' }],
    phone: [data.phone || '', [validators.Required()], { label: 'Phone', type: 'text' }],
    country: [data.country || '', [validators.Required()], { 
      label: null, 
      type: 'select', 
      options: countryList
    }],
    state: [data.state || '', [validators.Required()], { 
      label: null, 
      type: 'select', 
      options: stateList
    }],
    suburb: [data.suburb || '', [], { 
      label: 'Suburb', 
      type: 'text'
    }],
    internationalCountry: [data.internationalCountry || '', [], { 
      label: 'Country', 
      type: 'text',
      disabled: true
    }],
    organization: [data.organization || '', [validators.Required()], { label: 'Organization', type: 'text' }],
    service: [data.service || '', [validators.Required()], { label: null, type: 'select', options: serviceList }],
    enquiry: [data.enquiry || '', [validators.Required()], { label: 'Your Message', type: 'textarea' }],
    attachments: [data.attachments || '', [], { label: 'Attachments', type: 'file' }]
  }); 
  return model;
}